// station-face: the card kind of every station's face.
export const FACE_KIND = 'station.face';
